$('.nav .menu-item a[href*="#"]').on('click', function(e) {
  
	e.preventDefault();

	var docURL = document.URL;
	var docURLHash = docURL.split('#')[1];
	var href = $(this).attr('href');
	var hash = href.split('#')[1];
	var path = href.split('#')[0];

	if ( !docURL.endsWith(path) && !docURLHash ) {
		console.log('if');
		window.location.href = href;

	} else {
 
		var el          = $('#' + hash);
		var elOffset    = el.offset();
		var elOffsetTop = elOffset.top;
		$('body').removeClass('menu-is-open');

		$('html, body').animate({
			scrollTop: elOffsetTop
		}, 750);

	}

});
